<script lang="ts">
    import KpSearch from './KpSearch.svelte';
    import KpSearchContext from '../kp-search-context/KpSearchContext.svelte';
    import type {StaticSearchParams} from 'typings/portaro.be.types';

    export let staticParams: Partial<StaticSearchParams> | undefined;
    export let localSearch = false;

    // todo: IMPORTANT: this is just temporary component for angular integration, do not use it in svelte
</script>

<KpSearchContext {staticParams} {localSearch} let:searchManager>
    <KpSearch {searchManager}/>
</KpSearchContext>